import _ from 'lodash'
import Icon from '../icon'
import KCasBox from './CasBox'
import KEmitter from '../../core/mixins/emitter/KEmitter'

export default {
  name: 'KCasNode',
  mixins: [KEmitter],
  components: { KCasBox },
  inject: ['KCasSection', 'KCasBox', 'onNodeClick'],
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      validator: (value) => !_.isNil(value),
      default() {
        return null
      },
    },
    children: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    context() {
      return this.KCasBox || {}
    },
    root() {
      return this.KCasSection || {}
    },
    expand() {
      const expandNode = this.context.expandNode
      return expandNode && expandNode === this
    },
    checked() {
      return _.includes(this.root.checked, this.value)
    },
    childChecked() {
      const checkedValues = this.root.checked
      let hasChecked = false
      _.forEach(checkedValues, v => {
        const node = this.tryFindNode(this.children, v)
        if (node) {
          hasChecked = true
          return false
        }
      })
      return hasChecked
    },
    // disabled() {
    //   const parent = this.context.node
    //   return parent && (parent.checked || parent.disabled)
    // },
  },
  render() {
    const checkbox = this.renderCheckbox()
    const expand = this.renderExpand()
    const icon = this.renderIcon()
    return <li class="km-cascade__node">
      <div
        class={{
          'km-cascade__node--inner': true,
          'is-expanded': this.expand,
          'is-disabled': this.disabled,
          'is-child-checked': this.childChecked,
        }}
      >
        {checkbox}
        {expand}
        {icon}
      </div>
    </li>
  },
  watch: {},
  methods: {
    renderCheckbox() {
      return <label
        title={this.label}
        class="km-cascade__checkbox"
      >
        <input
          class="km-cascade__input"
          type="checkbox"
          value={this.value}
          checked={this.checked}
          onClick={e => {
            e.preventDefault()
            _.delay(this.handleClick, 0)
          }}
          disabled={this.disabled}
        />
        {this.label}</label>
    },
    renderExpand() {
      return !_.isEmpty(this.children) ? <Icon
        class="km-cascade__expand"
        name={this.expand ? 'caret-up' : 'caret-down'}
        onClick={e => {
          e.stopPropagation()
          this.handleExpandClick()
        }}
      ></Icon> : null
    },
    renderIcon() {
      return this.expand ? [
        <Icon
          class="km-cascade__angle"
          name="caret-up"
        ></Icon>,
        <Icon
          class="km-cascade__angle angle-border"
          name="caret-up"
        ></Icon>,
      ] : null
    },
    handleExpandClick() {
      this.dispatch('KCasBox', 'k.cascade.expand', this)
    },
    checkLimit() {
      if (!this.checked && this.root.limit > 1 && this.root.checked.length >= this.root.limit) {
        return false
      }
      return true
    },
    handleClick() {
      switch (this.root.mode) {
        case 'tree':
          this.doTreeClick()
          break
        default:
          this.doIsolateClick()
          break
      }
    },
    doIsolateClick() {
      if (this.checkLimit()) {
        const node = this.getFormatNode(this)
        node.children = this.children
        this.onNodeClick(node)
      } else {
        this.$message({ type: 'warning', message: `最多只能选择 ${this.root.limit} 个` })
      }
    },
    doTreeClick() {
      const node = this.getFormatNode(this)
      node.children = this.children
      this.onNodeClick(node)
    },
    getFormatNode(node) {
      const n = { value: node.value, label: node.label }
      if (node.context.node) {
        n.parent = this.getFormatNode(node.context.node)
      }
      return n
    },
    tryFindNode(nodes, v) {
      if (_.isEmpty(nodes)) return
      let node = _.find(nodes, n => n.value === v)
      if (node) {
        return node
      } else {
        _.forEach(nodes, n => {
          node = this.tryFindNode(n.children, v)
          if (node) return false
        })
        return node
      }
    },
  },
}
